import React, { useState } from "react";
import orderIntentsImg from "../../order-intents.png";
import { t } from "i18next";

interface IntentsProps {
  data?: {
    value: string[];
    valueBulk: string[];
    type: string;
    valueDetail: {
      value: string[];
      valueDetails: string[];
      valueConfidence: number[];
    };
    valueAlgo: string[];
  };
}

export default function Intents({ data }: Readonly<IntentsProps>) {
  const [isVisible, setIsVisible] = useState(true);

  const isDataEmpty =
    !data || (!data.value.length && !data.valueBulk.length && !data.valueAlgo.length);

  if (isDataEmpty || !isVisible) return null;

  const title = data.value.join(" / ");

  const details = data.valueDetail.valueDetails.map((detail) => `- ${detail}`).join("\n");

  const handleHideComponent = () => {
    setIsVisible(false);
  };

  return (
    <div className="bg-vistawarningblue/30 w-full mr-3 rounded-xl relative my-4">
      <div>
        <div className="bg-vistawarningblue/70 rounded-t-xl">
          <h3 className="text-[#3a4d7c] font-bold text-large p-3 capitalize">{title}</h3>
        </div>

        <h3 className="text-gray-500 font-bold text-large pl-5 py-2">
          {t("intent_detected_on_document")}
        </h3>

        <div className="text-sm pl-5 w-[calc(100%-192px)] break-words whitespace-pre-line">
          {details}
        </div>

        <button
          type="button"
          className="bg-vistawarningblue text-white rounded-md py-1 px-3 ml-5 my-3 inline-block cursor-pointer focus:outline-none focus:ring focus:ring-vistawarningblue/50"
          onClick={handleHideComponent}
        >
          {t("hide_information")}
        </button>
      </div>

      <div className="absolute right-0 bottom-0">
        <img
          src={orderIntentsImg}
          alt={t("alt_vistaflow_customer_settings")}
          className="w-48 origin-left self-center"
        />
      </div>
    </div>
  );
}
